module.exports = __webpack_public_path__ + "img/Combo hotdog choridog.f7a449ac.jpeg";